// 获取当前语言的函数
const getCurrentLanguage = () => {
  // 优先从cookie获取
  if (typeof document !== 'undefined') {
    const cookieValue = document.cookie.split('; ').find((row) => row.startsWith('be-site#lang='));
    if (cookieValue) {
      return cookieValue.split('=')[1];
    }
  }

  // 从URL路径获取
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    if (path.startsWith('/nl')) return 'nl';
    if (path.startsWith('/en')) return 'en';
  }

  return 'en'; // 默认语言
};

export const formatCurrency = (amount, priceUnit = '£') => {
  if (!amount) {
    return '';
  }

  const currentLang = getCurrentLanguage();

  // 根据语言确定地区设置
  const getLocale = (lang) => {
    switch (lang) {
      case 'nl':
        return 'nl-NL';
      case 'en':
      default:
        return 'en-GB';
    }
  };

  const locale = getLocale(currentLang);

  // 如果提供了自定义价格单位，使用当前语言的数字格式
  if (priceUnit && priceUnit !== '£') {
    return `${priceUnit}${amount.toLocaleString(locale)}`;
  }

  // 根据当前语言选择默认货币和格式
  const currency = currentLang === 'nl' ? 'EUR' : 'GBP';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
  }).format(amount);
};

// 添加默认导出以兼容componentBuilder.js
export default { formatCurrency };
